<!-->┌──────────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│                                   Loading Display                                    │<- ->
<- ->└──────────────────────────────────────────────────────────────────────────────────────┘<--->
<template>
    <div>
        <div v-if="loading || message || messageHold || animation || animationHold || failure"
             :class="['loading', { message: message || messageHold, animation: animation || animationHold, failure }]">

            <div class="message" v-if="message || messageHold || animation || animationHold">
                <slot name="message">
                    <p>Loading, please wait ...</p>
                </slot>
            </div>
            <div class="animation" v-if="animation || animationHold">
                <slot name="animation">
                    <b v-for="n in 1">&times;</b>
                </slot>
            </div>
            <div class="failure" v-if="failure">
                <slot name="failure">
                    <p>An error has occurred</p>
                </slot>
                <button @click="$emit('try-again')">Try again</button>
            </div>

        </div>

        <div v-show="!(loading || message || messageHold || animation || animationHold || failure)">
            <slot />
        </div>
    </div>
</template>

<style scoped>
    .loading {
        height: 100%;
    }

    .failure {
        background: #F8F8F8;
        border: 1px solid #DDD;
    }

    .loading,
    .message,
    .animation,
    .failure {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    p {
        padding: 0.5em;
    }

    .animation .animation {
        flex-direction: row !important;
    }

    .animation .animation b {
        animation: spin 2s linear infinite;
        padding: 0 0.25em;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

</style>

<script>
    const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms))

    export default {
        name: 'LoadingAnimation',
        props: {
            isLoading: Boolean, //  True means we want to show the loading phases until isLoading goes false
            waitTimes: Object
        },

        data() {
            return {
                loading: this.isLoading,

                message: false,
                messageHold: false,
                animation: false,
                animationHold: false,
                failure: false,

                pending: null
            }
        },

        watch: {
            isLoading: {
                immediate: true,
                handler(nowLoading, wasLoading) {
                    if (!!nowLoading == !!wasLoading) return

                    let waitTimes = {
                        message: 1000,
                        messageMin: 1000,
                        animation: 3000,
                        animationMin: 3000,
                        failure: 7000,

                        ...this.waitTimes
                    }

                    this.message = false
                    this.animation = false

                    this.loading = nowLoading

                    if (wasLoading) {
                        this.pending = null
                    }

                    if (nowLoading) {
                        this.failure = false

                        let chain = this.pending = Math.random()

                        wait(waitTimes.message).then(() => {
                            if (this.pending == chain && this.isLoading) {
                                this.message = true

                                //  Don't unshow the message until messageMin
                                this.messageHold = true
                                wait(waitTimes.messageMin).then(() => {
                                    this.messageHold = false
                                })

                                wait(waitTimes.animation).then(() => {
                                    if (this.pending == chain && this.isLoading) {
                                        this.animation = true

                                        //  Don't unshow the animation until animationMin
                                        this.animationHold = true
                                        wait(waitTimes.animationMin).then(() => {
                                            this.animationHold = false
                                        })

                                        wait(waitTimes.failure).then(() => {
                                            this.message = false
                                            this.animation = false

                                            if (this.pending == chain && this.isLoading)
                                                this.failure = true
                                        })
                                    }
                                })
                            }
                        })
                    }
                }
            }
        }
    }
</script>
